module.exports = __webpack_public_path__ + "static/media/joshua_img.ddd2106a.svg";